export default "__VITE_ASSET__Bg037OOa__"